import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import PouleContainer from "../../containers/structure/PouleContainer";
import EditBracketContainer from "../../containers/structure/EditBracketContainer";
import DeleteBracketContainer from "../../containers/structure/DeleteBracketContainer";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import { languages } from "../../constants/languages";
import Button from "@material-ui/core/Button";
import AddIcon from "@material-ui/icons/Add";
import { Avatar } from "@material-ui/core";

const styles = (theme) => ({
  poulesRoot: {
    marginLeft: theme.spacing(3),
    marginRight: theme.spacing(3),
    [theme.breakpoints.down("xs")]: {
      marginLeft: theme.spacing(2),
      marginRight: theme.spacing(2),
    },
  },
});

const StyledAvatar = withStyles({
  img: {
    height: "unset",
    borderRadius: 4,
  },
})(Avatar);

const Bracket = (props) => (
  <Paper
    style={
      props.resultsPage
        ? { display: "inline-block", margin: "0 24px 15px 24px" }
        : { minWidth: 200, display: "inline-block", marginBottom: 15 }
    }
  >
    <div
      style={{
        display: "flex",
        alignItems: "center",
        height: 30,
        paddingLeft: 10,
        borderRadius: "4px 4px 0px 0px",
        background: props.theme.palette.primary.main,
      }}
    >
      <div
        style={{
          fontWeight: 500,
          color: "white",
          display: "flex",
          fontSize: "0.875rem",
        }}
      >
        {props.bracket.showSponsor && props.bracket.sponsorLogoURL && (
          <StyledAvatar
            variant="rounded"
            alt=""
            src={props.bracket.sponsorLogoURL}
            style={{ height: 20, width: 20, marginRight: 5 }}
          />
        )}
        {props.bracket.name +
          (props.bracket.showSponsor && props.bracket.sponsorName
            ? " - " + props.bracket.sponsorName
            : "")}
      </div>
      <div style={{ flex: "1 1 10%" }} />
      {!props.resultsPage && (
        <EditBracketContainer
          tournament={props.tournament}
          poules={props.poules}
          allPoules={props.allPoules}
          allBrackets={props.allBracketsForPhase}
          bracketsByKey={props.bracketsByKey}
          division={props.division}
          bracket={props.bracket}
          fase={props.fase}
          userStatus={props.userStatus}
          tournamentStatus={props.tournamentStatus}
          toggleFinishedDialog={props.toggleFinishedDialog}
          toggleUpgradeDialog={props.toggleUpgradeDialog}
          user={props.user}
        />
      )}
      {!props.resultsPage && (
        <DeleteBracketContainer
          tournament={props.tournament}
          poules={props.poules}
          handleDelete={props.handleDelete}
          subBracketsArray={props.subBracketsArray}
          tournamentStatus={props.tournamentStatus}
          toggleFinishedDialog={props.toggleFinishedDialog}
          bracketId={props.bracket.id}
          daysByKey={props.daysByKey}
        />
      )}
    </div>
    <div
      style={{
        whiteSpace: "nowrap",
        overflowX: "auto",
        display: "flex",
        alignItems: "flex-start",
        padding: "15px 0 0 15px",
      }}
    >
      {Object.keys(props.poulesPerRound)
        .reverse()
        .map((round, i) => {
          const poules = props.poulesPerRound[round];
          return (
            <div
              key={round}
              style={{
                display: "inline-block",
                marginRight: 15,
              }}
            >
              <Typography variant="body2">
                {languages.structure.finals[round]}
              </Typography>
              {poules.map((poule) => {
                // if (poule.losersFinal && !props.bracket.showLosersFinal) {
                //   return null;
                // }
                return (
                  <div key={poule.id}>
                    <PouleContainer
                      tournament={props.tournament}
                      divisionsObject={props.divisionsObject}
                      division={props.division}
                      poule={poule}
                      handleClickPouleSpot={props.handleClickPouleSpot}
                      resultSpotsNotDivided={props.resultSpotsAll.filter(
                        (resultSpot) => resultSpot.fromPoule === poule.id
                      )}
                      fase={props.fase}
                      faseStarted={props.faseStarted}
                      poulesByKey={props.poulesByKey}
                      belongsToBracket={true}
                      onRef={props.onRef}
                      toggleLosersFinal={props.toggleLosersFinal}
                      showLosersFinal={props.bracket.showLosersFinal}
                      toggleResultSpotType={props.toggleResultSpotType}
                      resultSpotsAll={props.resultSpotsAll}
                      bracketsByKey={props.bracketsByKey}
                      bracket={props.bracket}
                      userStatus={props.userStatus}
                      tournamentStatus={props.tournamentStatus}
                      toggleFinishedDialog={props.toggleFinishedDialog}
                      resultsPage={props.resultsPage}
                      daysByKey={props.daysByKey}
                      user={props.user}
                    />
                  </div>
                );
              })}
              {!props.resultsPage &&
                round === "2" &&
                props.bracket.size !== 2 &&
                !props.bracket.showLosersFinal && (
                  <Button
                    size="small"
                    variant="outlined"
                    color="default"
                    onClick={props.toggleLosersFinal}
                    style={{ width: 220 }}
                  >
                    <AddIcon style={{ height: 16, width: 16 }} />
                    {languages.structure.match}
                  </Button>
                )}
            </div>
          );
        })}
    </div>

    {!props.resultsPage &&
      Object.keys(props.poulesPerRound)
        .reverse()
        .map((key, i) => {
          return key !== "2" &&
            i !== 0 &&
            props.subBracketsArray.filter((b) => b.size === Number(key))
              .length === 0 ? (
            <div
              key={key}
              style={{
                paddingLeft: 15,
                paddingBottom: 15,
              }}
            >
              <EditBracketContainer
                tournament={props.tournament}
                division={props.division}
                brackets={props.allBrackets}
                poules={props.allPoules}
                allPoules={props.allPoules}
                allBrackets={props.allBracketsForPhase}
                fase={props.fase}
                poulesByKey={props.poulesByKey}
                bracketsByKey={props.bracketsByKey}
                resultSpotsAll={props.resultSpotsAll}
                subBracketTo={props.bracket.id}
                numToBracket={Number(key)}
                subtext={
                  " (" +
                  (Number(key) + 1) +
                  " " +
                  languages.structure.until +
                  " " +
                  (Number(key) + Number(key)) +
                  ")"
                }
                userStatus={props.userStatus}
                tournamentStatus={props.tournamentStatus}
                toggleFinishedDialog={props.toggleFinishedDialog}
                user={props.user}
              />{" "}
            </div>
          ) : null;
        })}
    {props.subBrackets.map((subBracket, i) => (
      <div key={i} style={{ padding: 15, float: "right" }}>
        {subBracket}
      </div>
    ))}
  </Paper>
);

Bracket.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles, { withTheme: true })(Bracket);
